export default "__VITE_ASSET__cS6H$tZU__"